import { useState } from 'react';
import { InboxController } from './interfaces';

export const useInboxController = (): InboxController => {
    const [activeTab, setActiveTab] = useState<string>('announcements');
    return {
        state: { activeTab },
        events: { onChangeTab: setActiveTab },
    };
};
